import {
  FETCH_BOOKING_LOCATION,
  FETCH_BOOKING_LOCATION_SUCCESS,
  FETCH_BOOKING_LOCATION_FAILED,
  STOP_LOCATION_FETCH,
  FETCH_VEHICLE_LOCATIONS,
  FETCH_VEHICLE_LOCATIONS_SUCCESS,
  FETCH_VEHICLE_LOCATIONS_FAILED
} from "../store/types";
import store from '../store/store';
import { getSupabase } from '../config/configureSupabase';

export const saveTracking = (bookingId, location) => {
  const supabase = getSupabase();
  if (supabase) {
    const profile = store.getState().auth?.profile;
    supabase.from('route_tracking').insert([{
      tenant_id: profile?.tenant_id,
      route_id: bookingId,
      vehicle_id: profile?.vehicle_id,
      lat: location.lat,
      lng: location.lng,
      heading: location.heading || 0,
      speed: location.speed || 0
    }]).then(({ error }) => {
      if (error) console.warn('saveTracking error:', error.message);
    });
  }
};

export const fetchBookingLocations = (bookingId) => (dispatch) => {
  const supabase = getSupabase();
  if (supabase) {
    dispatch({
      type: FETCH_BOOKING_LOCATION,
      payload: bookingId,
    });
    supabase
      .from('vehicle_locations')
      .select('*')
      .eq('route_id', bookingId)
      .maybeSingle()
      .then(({ data }) => {
        if (data) {
          dispatch({
            type: FETCH_BOOKING_LOCATION_SUCCESS,
            payload: { lat: data.lat, lng: data.lng }
          });
        }
      });
  }
};

export const stopLocationFetch = (bookingId) => (dispatch) => {
  dispatch({
    type: STOP_LOCATION_FETCH,
    payload: bookingId,
  });
};

export const saveUserLocation = (location) => {
  const supabase = getSupabase();
  if (!supabase || !location?.lat || !location?.lng) return;
  const profile = store.getState().auth?.profile;
  const uid = profile?.id || profile?.uid;
  if (!uid) return;
  const now = new Date().toISOString();
  const payload = {
    driver_id: uid,
    lat: location.lat,
    lng: location.lng,
    heading: location.heading || 0,
    speed: location.speed || 0,
    updated_at: now
  };
  if (profile?.tenant_id) payload.tenant_id = profile.tenant_id;
  if (profile?.vehicle_id) payload.vehicle_id = profile.vehicle_id;
  supabase.from('vehicle_locations').upsert(payload, { onConflict: 'driver_id' }).then(({ error }) => {
    if (error) console.warn('saveUserLocation vehicle_locations error:', error.message);
  });
  supabase.from('profiles').update({ last_location: { lat: location.lat, lng: location.lng, heading: payload.heading, speed: payload.speed }, last_location_at: now }).eq('id', uid).then(({ error }) => {
    if (error) console.warn('saveUserLocation profiles error:', error.message);
  });
};

export const fetchVehicleLocations = () => async (dispatch) => {
  const supabase = getSupabase();
  const profile = store.getState().auth?.profile;
  if (!supabase || !profile) return;
  const tId = profile.tenant_id || profile.tenantId || null;
  const isSuper = profile.is_superadmin || profile.usertype === 'superadmin' || profile.role === 'superadmin';
  dispatch({ type: FETCH_VEHICLE_LOCATIONS, payload: null });
  try {
    let q = supabase.from('vehicle_locations').select('*');
    if (tId && !isSuper) q = q.eq('tenant_id', tId);
    const { data, error } = await q;
    if (!error && data && data.length > 0) {
      dispatch({ type: FETCH_VEHICLE_LOCATIONS_SUCCESS, payload: data });
      return;
    }
    let pq = supabase.from('profiles').select('id, last_location, last_location_at, driver_active_status, tenant_id').eq('usertype', 'driver').not('last_location', 'is', null);
    if (tId && !isSuper) pq = pq.eq('tenant_id', tId);
    const { data: profs } = await pq;
    if (profs && profs.length > 0) {
      const mapped = profs.map(p => ({ driver_id: p.id, tenant_id: p.tenant_id, lat: p.last_location?.lat, lng: p.last_location?.lng, heading: p.last_location?.heading||0, speed: p.last_location?.speed||0, updated_at: p.last_location_at, driver_active_status: p.driver_active_status }));
      const filtered = mapped.filter(m=> m.lat && m.lng);
      dispatch({ type: FETCH_VEHICLE_LOCATIONS_SUCCESS, payload: filtered });
      return;
    }
    if (error) dispatch({ type: FETCH_VEHICLE_LOCATIONS_FAILED, payload: error.message });
    else dispatch({ type: FETCH_VEHICLE_LOCATIONS_SUCCESS, payload: [] });
  } catch (e) {
    dispatch({ type: FETCH_VEHICLE_LOCATIONS_FAILED, payload: e.message });
  }
};
